/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const TaskWorkingFilterPopup = ({
  setIsNoDefaultFilter = () => {},
  setfilterTaskFromDate,
  setfilterTaskToDate,
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const userObj = {
    label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
    value: userInfo._id,
  };

  const [tagList, setTagList] = useState([]);
  const [projectInput, setprojectInput] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [assignedToInput, setassignedToInput] = useState("");
  const [assignedToList, setassignedToList] = useState([]);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [assignedToValue, setassignedToValue] = useState(null);
  const [selectedAssignedTo, setselectedAssignedTo] = useState([]);

  const [filterList, setFilterList] = useState([]);

  const [filterValue, setFilterValue] = useState(null);
  const [filterId, setFilterId] = useState(null);
  const [filterName, setFilterName] = useState("");
  const [isDefaultFilter, setIsDefaultFilter] = useState(false);

  const [filterValidError, setFilterValidError] = useState(false);

  const [filterIsSaving, setFilterIsSaving] = useState(false);
  const [filterSavingErrorMessage, setFilterSavingErrorMessage] = useState("");

  const [errorMessage, seterrorMessage] = useState("");

  /* hook for validation */
  const [validation, setValidation] = useState({
    dateWarning: false,
  });

  /* function to validate form */
  const validationHandler = () => {
    let isValid = true;
    if (fromDate !== "" && toDate === "") {
      setValidation((prevState) => ({ ...prevState, dateWarning: true }));
      isValid = false;
    }
    return isValid;
  };

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_TAGS + `?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setTagList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //search input
  const projectInputHandler = (val) => {
    setprojectInput(val);
  };

  //assinged to input
  const assignedToInputHandler = (val) => {
    setassignedToInput(val);
  };

  //function for get project list
  const getProjectList = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_PROJECTLIST_BY_SEARCH}?token=${token}&searchtitle=${projectInput}`;
      const response = await getData(requestUrl);
      console.log(response);
      if (response.status) {
        setProjectList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all assigned to list
  const getAssignedToUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?token=${token}&userstringinput=${assignedToInput}&modulename=MOD_TASK`;

      console.log(requestUrl);

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setassignedToList([...response.data, userObj]);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for select assigned user
  const assignedToSelectionHandler = (val) => {
    if (val) {
      setassignedToValue(val);
      setselectedAssignedTo(val.map((item) => item.value));
    } else {
      setassignedToValue(null);
      setselectedAssignedTo([]);
    }
  };

  //** Function for save filter */
  const saveFilterHanlder = async () => {
    if (filterName === "") {
      setFilterValidError(true);
    } else {
      setFilterIsSaving(true);

      //set filter data for saving
      let filterData = {
        name: filterName,
        parameters: JSON.stringify({
          fromDate: fromDate,
          toDate: toDate,
        }),
        moduleslug: "MOD__WORKING_TASK",
        isdefault: isDefaultFilter,
      };

      // console.log(`filterData ==========>>>`, filterData);

      try {
        let requestUrl = url.API_BASE_URL;

        //check condition
        if (filterId) {
          requestUrl =
            requestUrl +
            url.API_UPDATE_FILTER +
            `/${filterId}` +
            `?token=${token}`;
        } else {
          requestUrl = requestUrl + url.API_ADD_NEW_FILTER + `?token=${token}`;
        }

        const response = filterId
          ? await putData(requestUrl, filterData)
          : await postData(requestUrl, filterData);

        setFilterIsSaving(false);

        console.log(`filterData response ==========>>>`, response);

        if (response.status) {
          searchHandler();
          if (filterId) {
            getAllFilters(false);
          } else {
            getAllFilters(true);
          }
        } else {
          setFilterSavingErrorMessage(response.message);
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  // delete selected filter from filter select
  const deleteSelectedFilter = async () => {
    if (filterId && filterName !== "") {
      setFilterValidError(false);
      try {
        let requestUrl =
          url.API_BASE_URL +
          url.API_DELETE_FILTER +
          `/${filterId}` +
          `?token=${token}`;

        const response = await deleteData(requestUrl);

        // console.log(`filterData response ==========>>>`, response);

        if (response.status) {
          getAllFilters(false);
          resetHandler();
        }
      } catch (error) {
        console.error(error.message);
      }
    } // resetHandler();
  };

  //function for default filter
  const getDefaultFilter = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_DEFAULT_FILTER +
        `?token=${token}&modulename=${moduleName}`;

      // console.log("filter request url >>", requestUrl);

      const response = await getData(requestUrl);

      // console.log("default filter response >>>", response);

      if (response.status) {
        if (response.data) {
          setIsNoDefaultFilter(false);
          let filterData = response.data;

          if (filterData.isdefault) {
            filterSelectionHandler(filterData);

            const jsonFilterData = JSON.parse(filterData.parameters);

            console.log(jsonFilterData);

            //check start date and end date are not empty.If end date empty then only search by start date
            if (jsonFilterData.fromDate != "") {
              setfilterTaskFromDate(jsonFilterData.fromDate);
            } else {
              setfilterTaskFromDate(filterTaskFromDate);
            }

            if (jsonFilterData.toDate != "") {
              setfilterTaskToDate(jsonFilterData.toDate);
            } else {
              setfilterTaskToDate(filterTaskToDate);
            }
          }
        } else {
          setIsNoDefaultFilter(true);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //* Function for assign search data for filter and close pop up
  const searchHandler = () => {
    if (validationHandler()) {
      seterrorMessage("");
      //check start date and end date are not empty.If end date empty then only search by start date
      if (fromDate != "") {
        setfilterTaskFromDate(fromDate);
      } else {
        setfilterTaskFromDate(filterTaskFromDate);
      }

      if (toDate != "") {
        setfilterTaskToDate(toDate);
      } else {
        setfilterTaskToDate(filterTaskToDate);
      }

      // close the offcanvas of filter
      let offCanvasPopup = document.querySelector("#taskWrokingFilter");
      let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
      offCanvas.hide();
      resetHandler();
    } else {
      seterrorMessage("Please fill the required fields");
    }
  };

  const resetHandler = () => {
    setFromDate("");
    setToDate("");
  };

  //   useEffect(() => {
  //     // getAllTags();
  //     getAllFilters(false);
  //     getDefaultFilter();
  //   }, []);

  useEffect(() => {
    if (projectInput.length > 0) {
      getProjectList();
    }
  }, [projectInput]);

  useEffect(() => {
    if (assignedToInput.length > 0) {
      getAssignedToUserList();
    }
  }, [assignedToInput]);

  return (
    <div
      className="offcanvas offcanvas-end custom-offcanvas"
      tabIndex="-1"
      id="taskWrokingFilter"
      aria-labelledby="taskWrokingFilterLabel"
    >
      <div className="offcanvas-header bg-primary text-white">
        <h5 className="offcanvas-title">Filter</h5>
        <button
          type="button"
          className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      <div className="offcanvas-body">
        <form onSubmit={(e) => e.preventDefault()}>
          {/* <!-- ========== Start date select Section ========== --> */}
          <div className="mb-4 border-bottom pb-3">
            <div className="d-flex align-items-center gap-2">
              <h6 className="fw-bold mb-3 flex-shrink-0">
                {t("Search Task in this Date Range")}
              </h6>
            </div>

            {/* <!-- ========== Start date input Section ========== --> */}
            <div className="row gx-2">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <input
                  type="date"
                  className="form-control border border-secondary rounded px-2"
                  placeholder={t("From date")}
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    setValidation((prevState) => ({
                      ...prevState,
                      dateWarning: false,
                    }));
                    seterrorMessage("");
                  }}
                />
              </div>
              <div className="col-lg-6 mb-3 mb-lg-0">
                <input
                  type="date"
                  className="form-control border border-secondary rounded px-2"
                  placeholder={t("To date")}
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                    setValidation((prevState) => ({
                      ...prevState,
                      dateWarning: false,
                    }));
                    seterrorMessage("");
                  }}
                />
              </div>
            </div>
            {/* <!-- ========== End date input Section ========== --> */}

            {validation.dateWarning && (
              <div className="error-message mt-3">
                <p className="d-flex align-items-center gap-1 text-danger">
                  <span className="material-symbols-outlined">warning</span>
                  <span>Please enter end date!</span>
                </p>
              </div>
            )}
          </div>
          {/* <!-- ========== End date select Section ========== --> */}

          {/* <div className="form-group mb-4">
            <label htmlFor="Name" className="d-block fs-sm fw-semibold mb-2">
              <h3>{t("Assigned To")}</h3>{" "}
            </label>
            <Select
              isMulti
              placeholder={t("Type user name or email")}
              options={assignedToList}
              value={assignedToValue}
              onChange={(val) => {
                assignedToSelectionHandler(val);
              }}
              onInputChange={(val) => {
                assignedToInputHandler(val);
              }}
            />
          </div> */}

          {/* <!-- ========== Start filter title input Section ========== --> */}
          {/* <div className="form-group mt-4">
            <label
              htmlFor="inputtitle"
              className="d-block fs-sm fw-semibold mb-2"
            >
              <h3>{t("Save as new filter")}</h3>{" "}
            </label>
            <div className="d-flex align-items-center gap-1">
              <input
                type="text"
                className="form-control fs-sm shadow-none"
                placeholder={t("Save as new filter")}
                value={filterName}
                onChange={(e) => {
                  setFilterName(e.target.value);
                  setFilterValidError(false);
                  setFilterSavingErrorMessage("");
                }}
              />

              <Link to="#" onClick={deleteSelectedFilter}>
                <span className="d-block material-symbols-outlined">
                  delete
                </span>
              </Link>
            </div>

            {filterValidError && (
              <div className="error-message mt-2">
                <p className="d-flex align-items-center gap-1 text-danger">
                  <span className="material-symbols-outlined">warning</span>
                  <span>Please enter a title or select a filter!</span>
                </p>
              </div>
            )}
          </div> */}
          {/* <!-- ========== End filter title input Section ========== --> */}

          {/* <!-- ========== Start is default checkbox Section ========== --> */}

          {/* <div className="form-check d-flex align-items-center gap-2 cursor-pointer p-0 m-0 mt-4">
            <input
              className="form-check-input d-block bg-transparent border-2 border-gray-600 shadow-none m-0"
              type="checkbox"
              id="agree"
              checked={isDefaultFilter}
              onChange={(e) => {
                setIsDefaultFilter(e.target.checked);
                setFilterSavingErrorMessage("");
              }}
            />
            <label
              className="form-check-label fs-lg fw-semibold"
              htmlFor="agree"
            >
              {t("Is default filter")}
            </label>
          </div> */}

          {/* <!-- ========== End is default checkbox Section ========== --> */}

          {/* <!-- ========== Start filter saving error message Section ========== --> */}
          {/* {filterSavingErrorMessage === "" ? null : (
            <div className="error-message mt-4">
              <p className="d-flex align-items-center gap-1 text-danger">
                <span className="material-symbols-outlined">warning</span>
                <span>{filterSavingErrorMessage}!</span>
              </p>
            </div>
          )} */}
          {/* <!-- ========== End filter saving error message Section ========== --> */}

          {/* <!-- ========== Start error message Section ========== --> */}
          {errorMessage === "" ? null : (
            <div className="error-message mt-3">
              <p className="d-flex align-items-center gap-1 text-danger">
                <span className="material-symbols-outlined">warning</span>
                <span>{errorMessage}!</span>
              </p>
            </div>
          )}
          {/* <!-- ========== End error message Section ========== --> */}

          {/* <!-- ========== Start apply button Section ========== --> */}
          {/* <div className="action d-flex gap-2 mt-4">
            <button
              type="button"
              className="btn btn-primary flex-fill"
              aria-label="Close"
              onClick={searchHandler}
            >
              {t("Search Tasks")}
            </button> */}

          {/* <button
              type="button"
              className="btn btn-primary flex-fill"
              // data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={saveFilterHanlder}
              disabled={filterIsSaving ? true : false}
              style={{
                cursor: filterIsSaving ? "not-allowed" : "pointer",
              }}
            >
              {t("Save and Apply Filter")}
              {filterIsSaving && (
                <div
                  className="mx-2 spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </button> */}
          {/* </div> */}
          {/* <!-- ========== End apply button Section ========== --> */}
        </form>
      </div>

      {/* Fixed Apply Filter and Reset Buttons */}
      <div className="offcanvas-footer bottom-0 start-0 end-0 bg-white p-3 border-top d-flex justify-content-between align-items-center">
        <button
          type="button"
          className="btn btn-primary flex-grow-1"
          onClick={searchHandler}
        >
          {t("Search Tasks")}
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary ms-2"
          onClick={() => {
            resetHandler();
            // reloadList(); // Assuming reloadList is a prop or function to refresh the task list
          }}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default TaskWorkingFilterPopup;
